import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { Paper, Skeleton, Stack, Typography } from '@mui/material';
import type { StatusesByField } from 'business/types';
import type {
    CatalogSelection,
    DataCatalogField,
} from 'modules/datacatalog/types';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';

import FieldDetail from './components/FieldDetail';

type Props = {
    selection: CatalogSelection | null;
    catalogMetadata?: DataCatalogField;
    isLoading?: boolean;
    displayedStatuses?: StatusesByField;
};

const DetailPanel = ({
    selection,
    catalogMetadata,
    isLoading,
    displayedStatuses,
}: Props) => {
    const { t } = useTranslation();

    if (!selection) {
        return (
            <Flex alignItems="center" justifyContent="center" height="100%">
                <Stack spacing={1} sx={{ alignItems: 'center' }}>
                    <TableChartOutlinedIcon
                        sx={{ fontSize: '3rem', opacity: 0.3 }}
                    />
                    <Typography variant="body2">
                        {t('dataCatalog.emptySelectionHint')}
                    </Typography>
                </Stack>
            </Flex>
        );
    }

    return (
        <Paper
            variant="outlined"
            sx={{
                height: '100%',
                p: 3,
                overflow: 'auto',
                borderRadius: 2,
                bgcolor: 'background.paper',
            }}
        >
            {isLoading || !catalogMetadata ? (
                <Stack spacing={1.5}>
                    <Skeleton variant="text" width="40%" height={20} />
                    <Skeleton variant="text" width="60%" height={32} />
                    <Skeleton variant="rectangular" height={80} />
                    <Skeleton variant="rectangular" height={60} />
                </Stack>
            ) : (
                <FieldDetail
                    key={selection.name}
                    selection={selection}
                    catalogMetadata={catalogMetadata}
                    displayedStatuses={displayedStatuses}
                />
            )}
        </Paper>
    );
};

export default DetailPanel;
